import { gql } from '@apollo/client'

export const FRAGMENT_SENTIMENT = gql`
  fragment FragmentSentiment on BrandTerritory {
    territorySentiment {
      title(filters: $filters) {
        positive
        negative
        neutral
        positiveVariation
        negativeVariation
        neutralVariation
      }
    }
  }
`

export const FRAGMENT_SENTIMENT_POSTS = gql`
  fragment FragmentSentimentPosts on BrandTerritory {
    territorySentimentPosts: territoryMostEngaged {
      positive: posts(territoryContentFilters: { titleSentiment: positive }, filters: $filtersPosts, limit: 2) {
        postId
        provider
        thumbnail
      }
      negative: posts(territoryContentFilters: { titleSentiment: negative }, filters: $filtersPosts, limit: 2) {
        postId
        provider
        thumbnail
      }
      neutral: posts(territoryContentFilters: { titleSentiment: neutral }, filters: $filtersPosts, limit: 2) {
        postId
        provider
        thumbnail
      }
    }
  }
`

export const FRAGMENT_SENTIMENT_POSTS_V2 = gql`
  fragment FragmentSentimentPostsV2 on BrandTerritory {
    territorySentimentPosts: territoryMostEngaged {
      positive: posts(
        territoryContentFilters: { titleSentiment: positive, territoryIds: $territoryIds }
        filters: $filtersPosts
        limit: 2
      ) {
        postId
        provider
        thumbnail
      }
      negative: posts(
        territoryContentFilters: { titleSentiment: negative, territoryIds: $territoryIds }
        filters: $filtersPosts
        limit: 2
      ) {
        postId
        provider
        thumbnail
      }
      neutral: posts(
        territoryContentFilters: { titleSentiment: neutral, territoryIds: $territoryIds }
        filters: $filtersPosts
        limit: 2
      ) {
        postId
        provider
        thumbnail
      }
    }
  }
`
